export default function isNameInvalid(name) {
    return !/^[A-Za-z ,'-]+$/i.test(name);
}
